import api from '../../../api';
import { SmartschoolSchool } from '../../../api/my-account';

export interface SmartschoolRequestPayload {
  enabled: boolean;
  clientId: string;
  clientSecret: string;
  validationCode: string;
}

export async function updateSmartschoolOneRoster(
  id: string,
  payload: SmartschoolRequestPayload,
): Promise<SmartschoolSchool> {
  const { data } = await api.patch<SmartschoolSchool>(`/studio/schools/smartschool/${id}`, payload);

  return data;
}
